import { icons } from 'lucide-react'

const LABEL_WORD_INITIAL_PATTERN = /(^|[-_])(\w)/g

export const EMPTY_TAG = {
  label: '',
  bg_color: '#3B82F6',
  text_color: '#FFFFFF',
  icon: '',
  font_style: 'normal',
  position: 'bet-topline',
  sort_order: 0,
}

function pascalCase(str) {
  return str.replace(LABEL_WORD_INITIAL_PATTERN, (_, _sep, c) => c.toUpperCase())
}

export function getTagStyles(fontStyle) {
  const italic = fontStyle === 'italic' || fontStyle === 'bold-italic'
  const bold = fontStyle === 'bold' || fontStyle === 'bold-italic'
  return {
    fontStyle: italic ? 'italic' : 'normal',
    fontWeight: bold ? '700' : 'normal',
  }
}

export function getIconComponent(iconName) {
  if (!iconName) return null
  const pascal = pascalCase(iconName)
  return icons[pascal] || null
}

export function getTagDisplayStyle(tag) {
  const fontStyles = getTagStyles(tag?.font_style)
  return {
    backgroundColor: tag?.bg_color || '#e5e7eb',
    color: tag?.text_color || '#374151',
    ...fontStyles,
    fontWeight: fontStyles.fontWeight === '700' ? '700' : '600',
  }
}
